module.exports = __webpack_public_path__ + "media/styles/images/png/check-gray-4e4af13ce896d4fc0281dd357f72a918.png";